import React, { Component, Fragment } from "react";
import MetaTags from "react-meta-tags";
import Header from "../layouts/Header";
import Footer from "../layouts/Footer";
import Breadcrumb from "../layouts/Breadcrumb";
import Clients from "../layouts/Clients";
import Content from "../sections/blogdetails/Content";

class Privacy extends Component {
  componentDidMount = () => {
    window.scrollTo(0, 0);
  };
  render() {
    return (
      <Fragment>
        <MetaTags>
          <title>Privacy - Policy | G9 Gems</title>
          <meta name="description" content="#" />
        </MetaTags>
        <Header />

        <div className="section sigma_post-single mt-5">
          <div className="container">
            <div className="row">
              <div className="section-title text-center">
                <h4>Privacy P0licy</h4>
                <ol>
                  <li>
                    The terms "We" / "Us" / "Our"/”Company” individually and
                    collectively refer to Gems G9 Private Limited.
                    and the terms "You" /"Your" / "Yourself" refer to the users.
                  </li>
                  <li>
                    This Privacy Policy is an electronic record in the form of
                    an electronic contract formed under the information
                    Technology Act, 2000 and the rules made thereunder and the
                    amended provisions pertaining to electronic documents /
                    records in various statutes as amended by the information
                    Technology Act, 2000. This Privacy Policy does not require
                    any physical, electronic or digital signature.
                  </li>
                  <li>
                    This Privacy Policy is a legally binding document between
                    you and o Fireblaze Technologies Private Limited (both terms
                    defined below). The terms of this Privacy Policy will be
                    effective upon your acceptance of the same (directly or
                    indirectly in electronic form, by clicking on the I accept
                    tab or by use of the website or by other means) and will
                    govern the relationship between you and o Fireblaze
                    Technologies Private Limited for your use of the website
                    “Website” (defined below).
                  </li>
                  <li>
                    This document is published and shall be construed in
                    accordance with the provisions of the Information Technology
                    (reasonable security practices and procedures and sensitive
                    personal data of information) rules, 2011 under Information
                    Technology Act, 2000; that require publishing of the Privacy
                    Policy for collection, use, storage and transfer of
                    sensitive personal data or information.
                  </li>
                  <li>
                    Please read this Privacy Policy carefully by using the
                    Website, you indicate that you understand, agree and consent
                    to this Privacy Policy. If you do not agree with the terms
                    of this Privacy Policy, please do not use this Website.
                  </li>
                  <li>
                    By providing us your Information or by making use of the
                    facilities provided by the Website, You hereby consent to
                    the collection, storage, processing and transfer of any or
                    all of Your Personal Information and Non-Personal
                    Information by us as specified under this Privacy Policy.
                    You further agree that such collection, use, storage and
                    transfer of Your Information shall not cause any loss or
                    wrongful gain to you or any other person.
                  </li>
                  <li>
                    to: Mr Rohit Kothari 
                    https://www.gemsgnine.com/ G9 Gems Private Limited
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </Fragment>
    );
  }
}

export default Privacy;
